import { } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';

type Props = SetupProps<typeof TimeTicketWeekConfirmModalSetupService.props>

export default class TimeTicketWeekConfirmModalSetupService extends BaseSetupService<Props> {
	static readonly props = {
		attachmentsLength: {
			type: Number,
			default: 0,
		},
		comment: {
			type: String,
			default: null,
		},
	};

	constructor (props?: Props) {
		super(props);
	}

	get attachmentAlert () {
		if (this.props.attachmentsLength) {
			return {
				color: 'info' as Orion.Color,
				label: `Vous avez ajouté ${'justificatif'.pluralize(this.props.attachmentsLength)} à ce relevé d'heures.`,
			};
		} else {
			return {
				color: 'warning' as Orion.Color,
				label: `Aucun justificatif n'a été ajouté à ce relevé d'heures.`,
			};
		}
	}
}
